import React from "react";
import "./NotFound.css";
import backgroundImg from "../../img/background.png";
import { useHistory } from "react-router";
const NotFound = () => {
  const history = useHistory();
  return (
    <div className="d-flex flex-column justify-content-center align-items-center pe-5 my-5">
      <div className="ps-5">
        <img src={backgroundImg} alt="" />
      </div>
      <h2 className="text-danger m-4">
        The page you are looking for doesn't exist.
      </h2>
      <div>
        <button
          onClick={() => history.push("/home")}
          type="button"
          className="btn fs-5 btn-outline-success  py-2 px-4"
        >
          Go back to our Homepage.
        </button>
      </div>
    </div>
  );
};

export default NotFound;
